import { Guid } from "guid-typescript";
import { WorkScheduleProposalStatusEnum } from "./enum-status-change";

export class UpdateStatusModel {
  id?: Guid;
  status: WorkScheduleProposalStatusEnum;
}
